<template>
  <div id="app">
    <main class>
      <transition name="fade">
        <router-view />
      </transition>
    </main>
  </div>
</template>

<script>
import firebaseInstance from "./util/firebase";
import router from "./router";
import store from "./store";

export default {
  name: "App",
  metaInfo: {
    title: 'HourPrice'
  },
  data() {
    return {};
  },
  props: [],
  components: {},
  methods: {},
  computed: {},
  created() {
    console.log("* Loaded app root");
  }
};
</script>

<style lang="scss">
@import "./styles/settings.scss";
@font-face {
  font-family: "Nexa-Light";
  font-weight: 300;
  src: url("/fonts/Nexa/Nexa-Light.otf");
}
@font-face {
  font-family: "Nexa-Bold";
  font-weight: 600;
  src: url("/fonts/Nexa/Nexa-Bold.otf");
}
@font-face {
  font-family: "Nexa";
  font-weight: 600;
  src: url("/fonts/Nexa/Nexa-Bold.otf");
}
@font-face {
  font-family: "Nexa";
  font-weight: 300;
  src: url("/fonts/Nexa/Nexa-Light.otf");
}
@font-face {
  font-family: "GG";
  font-weight: 300;
  src: url("/fonts/Galano-Grotesque/Galano-Grotesque-Light.otf");
}
@font-face {
  font-family: "GG";
  font-weight: 400;
  src: url("/fonts/Galano-Grotesque/Galano-Grotesque.otf");
}
@font-face {
  font-family: "GG";
  font-weight: 500;
  src: url("/fonts/Galano-Grotesque/Galano-Grotesque-Semi-Bold.otf");
}
.nexa-font-bold {
  font-family: "Nexa-Bold";
  font-weight: 600;

  p {
    font-family: "Nexa-Bold";
    font-weight: 600;
  }
}

.gg-font {
  font-family: "GG";
  /*font-weight: 400;*/

  p {
    font-family: "GG";
    /*font-weight: 400;*/
  }
}
</style>
